import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/diagnostic/page.jsx");
